<!-- MOLECULE: DrawerHeaderRail.vue -->
<!-- Navigation drawer header rendered in rail (collapsed) mode showing only the app logo. -->

<script setup lang="ts">
//
// Props & Emits
//
interface Props {
  appLogoRailMode?: string | null;
}

const props = withDefaults(defineProps<Props>(), {
  appLogoRailMode: null,
});

//
// Composables
//
const logoSrc = useAssetPath(
  "/app-logo-primary.png",
  toRef(() => props.appLogoRailMode),
);
</script>

<template>
  <v-list density="compact" nav>
    <v-list-item class="px-1">
      <v-img :src="logoSrc" :width="30" :height="30" alt="App Logo" />
    </v-list-item>
  </v-list>
</template>
